import { horizontalRotate, verticalRotate } from '../js/rotate'
import { mapMutations } from 'vuex'
import { refreshBox } from '@/views/template-configuration/utils/js/help'
import { cloneDeep } from 'lodash'
const examNoHandle = {
	data() {
		return {
			//手动配置 默认的额数据
			opeForm: {
				rowNum: '10',
				colNum: '9',
				width: '40',
				height: '30'
			},
			//手动配置 考号所有小框框
			resultBox: [],
			//所有 考号所有小框框,
			resultHorizontalObj: {},
			//手动配置  框选的状态
			isRecogniseDo: true,
			//缩放位置信息
			resizeDragVal: {
				left: 150,
				top: 100,
				width: 0,
				height: 0
			},
			//剪切的图片
			clipImg: '',
			//默认剪切的图片距离顶部的位置
			resizeDragValTop: 100
		}
	},
	watch: {
		//切图
		clipImg: {
			handler(val) {
				const _this = this
				let img = new Image()
				img.src = val
				img.onload = function() {
					_this.resizeDragVal.width = img.width
					_this.resizeDragVal.height = img.height
					_this.generateNo()
				}
			}
		}
	},
	mounted() {
		this.handleKeys()
	},
	methods: {
		...mapMutations('examination/configation', ['setTempRectExamNoInfo']),
		handleKeys() {
			const _this = this
			document.onkeydown = function(event) {
				event.preventDefault()
				if (_this.tabActive === 'examNo' && _this.rectDetail[0].appendInfo && _this.examNoActiveIndex !== null) {
					let appendInfo = JSON.parse(_this.rectDetail[0].appendInfo)
					let box = appendInfo.box
					if (_this.examNoActiveIndex !== -1 && event.keyCode === 37) box[_this.examNoActiveIndex].x -= 1
					if (_this.examNoActiveIndex !== -1 && event.keyCode === 38) box[_this.examNoActiveIndex].y -= 1
					if (_this.examNoActiveIndex !== -1 && event.keyCode === 39) box[_this.examNoActiveIndex].x += 1
					if (_this.examNoActiveIndex !== -1 && event.keyCode === 40) box[_this.examNoActiveIndex].y += 1
					appendInfo.box = box
					_this.rectDetail[0].appendInfo = JSON.stringify(appendInfo)
					const params = {
						subjectId: _this.query.subjectId,
						examId: _this.query.examId,
						versionId: _this.tempEditImgInfo.versionId,
						ppiId: _this.rectDetail[0]['pkId'],
						ppiStr: JSON.stringify(_this.rectDetail[0])
					}
					refreshBox(_this, 'Cv/refreshPpi', params)
				}
				if (_this.tabActive === 'examNo' && _this.handleActive && _this.handHandleState) {
					if (event.keyCode === 37) _this.resizeDragVal.left -= 1
					if (event.keyCode === 39) _this.resizeDragVal.left += 1
					if (event.keyCode === 38) {
						_this.resizeDragVal.top -= 1
						_this.resizeDragValTop = _this.resizeDragVal.top
					}
					if (event.keyCode === 40) _this.resizeDragVal.top += 1
				}
			}
		},
		//激活手动配置
		activeHandleRect() {
			this.handleActive = !this.handleActive
		},
		//------------------------
		//竖直向下
		verticalDownRotation() {
			this.verticalRotate(0.1)
		},
		//竖直向上
		verticalUpRotation() {
			this.verticalRotate(-0.1)
		},
		//handle 竖直方向上的旋转
		verticalRotate(degree) {
			verticalRotate({ box: this.resultHorizontalObj, title: [] }, degree).then(resp => (this.resultBox = resp.box))
			this.refreshState()
		},
		//------------------------
		//水平向右旋转
		horizontalRightRotation() {
			this.horizontalRotate(0.1)
		},
		// 水平向左旋转
		horizontalLeftRotation() {
			this.horizontalRotate(-0.1)
		},
		// 水平方向旋转
		horizontalRotate(degree) {
			horizontalRotate({ box: this.resultHorizontalObj, title: [] }, degree).then(resp => (this.resultBox = resp.box))
			this.refreshState()
		},
		//------------------------
		// 生成
		saveExamNo() {
			this.setHandHandleState(false)
			this.handleActive = false
			this.startX += this.resizeDragVal.left - 150
			this.startY += this.resizeDragVal.top - 100 + this.scrollVal
			this.endX = this.startX + this.resizeDragVal.width
			this.endY = this.startY + this.resizeDragVal.height
			this.addDropRect(this.endX, this.endY, this.startX, this.startY, this.resultBox)
		},
		inputKeyDown(event, code) {
			let nums = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
			if (event.key === 'Enter') {
				this.generateNo()
			} else if (event.key === 'Delete' || event.key === 'Backspace') {
				this.opeForm[code] = this.opeForm[code].slice(0, this.opeForm[code].length - 1) || ''
			} else if (nums.includes(event.key)) {
				this.opeForm[code] += event.key
			}
		},
		// 修改行数设列数
		rowNumStepVal(val, type) {
			this.opeForm[type] = val
			this.generateNo()
		},
		//生成小框框
		generateNo() {
			this.handleActive = false
			let miniWidth = (this.resizeDragVal.width - Number(this.opeForm.colNum) * Number(this.opeForm.width)) / (Number(this.opeForm.colNum) + 1)
			let miniHeight = (this.resizeDragVal.height - Number(this.opeForm.rowNum) * Number(this.opeForm.height)) / (Number(this.opeForm.rowNum) + 1)
			let resultBox = [],
				resultHorizontalObj = {}
			for (let i = 1; i <= Number(this.opeForm.rowNum); i++) {
				if (!resultHorizontalObj[i]) resultHorizontalObj[i] = []
				for (let j = 1; j <= Number(this.opeForm.colNum); j++) {
					const resPos = {
						w: Number(this.opeForm.width),
						h: Number(this.opeForm.height),
						initX: miniWidth * j + Number(this.opeForm.width) * (j - 1),
						initY: miniHeight * i + Number(this.opeForm.height) * (i - 1),
						row: i,
						col: j,
						left: 0,
						top: 0,
						v: i - 1,
						r: 0,
						c: 0,
						i: 0
					}
					resPos.x = resPos.left + resPos.initX
					resPos.y = resPos.top + resPos.initY
					resultBox.push(resPos)
					resultHorizontalObj[i].push(resPos)
				}
			}
			this.resultBox = resultBox
			this.resultHorizontalObj = Object.values(resultHorizontalObj).flat(Infinity)
		},

		//缩放
		resizestop(prev, cur) {
			const oldMinWidth = (prev.width - Number(this.opeForm.colNum) * Number(Number(this.opeForm.width))) / (Number(this.opeForm.colNum) + 1)
			const oldMinHeight = (prev.height - Number(this.opeForm.rowNum) * Number(Number(this.opeForm.height))) / (Number(this.opeForm.rowNum) + 1)
			this.resizeDragVal = cur
			this.resizeDragValTop = cur.top + this.scrollVal
			this.fixGenerateNo(oldMinWidth, oldMinHeight)
			this.refreshState()
		},
		// 修改生成位置
		fixGenerateNo(oldMinWidth, oldMinHeight) {
			let miniWidth = (this.resizeDragVal.width - Number(this.opeForm.colNum) * Number(Number(this.opeForm.width))) / (Number(this.opeForm.colNum) + 1)
			let miniHeight = (this.resizeDragVal.height - Number(this.opeForm.rowNum) * Number(Number(this.opeForm.height))) / (Number(this.opeForm.rowNum) + 1)
			const dragVal = cloneDeep(this.resizeDragVal)
			dragVal.left += oldMinWidth - miniWidth
			dragVal.top += oldMinHeight - miniHeight
			this.resultBox.forEach(res => {
				res.w = Number(this.opeForm.width)
				res.h = Number(this.opeForm.height)
				res.initX = miniWidth * res.col + Number(this.opeForm.width) * (res.col - 1)
				res.initY = miniHeight * res.row + Number(this.opeForm.height) * (res.row - 1)
				res.x = res.left + res.initX
				res.y = res.top + res.initY
			})
			this.dragstop(dragVal)
			this.refreshState()
		},
		//拖拽
		dragstop(val) {
			this.resizeDragVal = val
			this.resizeDragValTop = val.top + this.scrollVal
			this.refreshState()
		},
		refreshState() {
			const _this = this
			this.isRecogniseDo = false
			setTimeout(() => (_this.isRecogniseDo = true), 300)
		},
		//  返回
		backRecognise() {
			this.handleActive = false
			this.$delete(this.rectDetail, this.rectDetail.length - 1)
			this.setTempRectExamNoInfo(this.rectDetail)
			this.setHandHandleState(false)
		}
	}
}
export default examNoHandle
